<template>
	<div class="layout-row" style="min-height: 100vh;">
	        <div class="d-flex flex-column flex">
	            <div class="row no-gutters h-100">
	                <div class="col-md-6 bg-primary sticky">
	                    <div class="p-3 p-md-5 d-flex flex-column h-100">
                            <img src="../assets/pragma_logo_alternative.png" width="400" style="max-width:90%;">     
	                        <div class="d-flex flex align-items-center justify-content-center">
	                        </div>
	                        <div class="d-flex text-sm text-fade">
	                            <a href="#" class="text-white">About</a>
	                            <span class="flex"></span>
                                <a href="https://pragmapredict.com/terms-of-service/" class="text-white mx-1">Terms</a>
                                <a href="https://pragmapredict.com/privacy-policy/" class="text-white mx-1">Policy</a>
	                        </div>
	                    </div>
	                </div>
                    <div class="col-md-6" id="content-body">
                        <div class="p-3 p-md-5">
                            <div v-if="successMessage" class="alert alert-success alert-dismissible fade show" key="success-alert" role="alert"> 
                                {{ successMessage }}
                            </div>
                            <div v-if="errorMessage" class="alert alert-danger alert-dismissible fade show" key="error-alert" role="alert"> 
                                {{ errorMessage }}
                            </div>
                            <transition name="page" mode="out-in" class="relative-parent">
                                <router-view @error="onError" @success="onSuccess"></router-view> 
                            </transition>
                        </div>
                    </div>
	            </div>
	        </div>
	</div>
</template>

<script type="text/javascript">
export default {
    data() {
		return {
            errorMessage: "",
            successMessage: "",
		}; 
    },
    
    beforeRouteUpdate(to, from, next) {
        this.errorMessage = undefined;
        this.successMessage = undefined;
        next();
    },

    methods: {
        onError(message) {
            console.log("Message recieved!");
            this.errorMessage = message;
            this.successMessage = undefined;
        },
        onSuccess(message) {
            console.log("Message recieved!");
            this.errorMessage = undefined;
            this.successMessage = message;
        }
    }
};

</script>

<style>
.page-enter-active, .page-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.page-enter, .page-leave-to {
  opacity: 0;
  transform: translateX(-30%);
}
</style>



// WEBPACK FOOTER //
// src/components/AuthLayout.vue